import {Component, ViewEncapsulation} from "@angular/core";

@Component({
    selector     : '.email-demo',
    encapsulation: ViewEncapsulation.None,
    template: `<h4>Email Address</h4>
<h5>Example</h5>
<div class="card card-body bg-light form-group">
    <form #testForm="ngForm">
        <check-box [(ngModel)]="model.required" name="required" label="Is Required" labelPlacement="after"></check-box>
        <email
                [name]="model.name"
                label="Email Address"
                [(ngModel)]="model.value"
                [parentFormGroup]="testForm.form"
                [required]="model.required"
                [placeholder]="model.placeholder"></email>
        <submit-button label="Submit" [formGroup]="testForm.form"></submit-button>
    </form>
</div>
<h5>Data Model</h5>
<pre class="card card-body bg-light">{{ model | json }}</pre>
<h5>Markup</h5>
<pre class="card card-body bg-light">{{ markup }}</pre>
`
})
export class EmailDemoComponent {

    model = {
        id         : 'emailField',
        name       : 'emailField',
        match      : '',
        required   : false,
        placeholder: 'Example Email Field',
        value      : ''
    };

    markup = `
<email
        [name]="model.name"
        label="Email Address"
        [(ngModel)]="model.value"
        [required]="model.required"
        [placeholder]="model.placeholder"></email>
<email name="confirmEmail" label="Confirm Email Address"
       [(ngModel)]="model.match"
       [matchValue]="{value:model.value,label:'Email Address'}"
       [required]="true"
       placeholder="Confirm Email"></email>
    `;



}
